import { Fragment, useEffect } from "react";
import ReactDOM from "react-dom";
import classes from "./Modal.module.css";

const Backdrop = (props) => {
  return <div className={classes.backdrop} />;
};

const ModalOverlay = (props) => {
  const modalStyle = props.style || {};
  const hasCustomWidth = modalStyle.minWidth || modalStyle.maxWidth || modalStyle.width;
  
  // If custom width is provided, add a class for centering
  // Also apply transform via inline style to ensure it works with animation
  const combinedStyle = hasCustomWidth
    ? {
        ...modalStyle,
        // Apply transform inline to ensure it works with animation
        transform: "translateX(-50%) translateY(0)",
        left: "50%",
      }
    : modalStyle;

  const className = `${classes.modal} ${hasCustomWidth ? classes.modalCustomWidth : ""} ${props.className || ""}`.trim();

  return (
    <div 
      className={className}
      style={Object.keys(combinedStyle).length > 0 ? combinedStyle : undefined}
    >
      <div className={classes.content} style={{ position: "relative" }}>
        {props.children}
      </div>
    </div>
  );
};

const portalElement = document.getElementById("overlays");

const ModalNew = (props) => {
  // Lock body scroll when modal is open
  useEffect(() => {
    // Save the original overflow value
    const originalOverflow = document.body.style.overflow;
    // Lock the body scroll
    document.body.style.overflow = "hidden";
    
    // Cleanup: restore original overflow when modal closes
    return () => {
      document.body.style.overflow = originalOverflow;
    };
  }, []);

  return (
    <Fragment>
      {ReactDOM.createPortal(<Backdrop />, portalElement)}
      {ReactDOM.createPortal(
        <ModalOverlay className={props.className} style={props.style}>
          {props.children}
        </ModalOverlay>,
        portalElement
      )}
    </Fragment>
  );
};

export default ModalNew;
